import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PrimarySmallBlueButton from '../../../../components/customButtons/PrimarySmallBlueButton';

export default function NoTestAvailableScreen({text, subText ,maxWidth, buttonName,topimageWidth, topImage, redirectionLink,startIcon}) {
      const navigate = useNavigate();

      const handleNavigation =()=>{
       console.log("redirectionLink",redirectionLink)
        navigate(redirectionLink)
      }
  return (
 <Box
      sx={{
        maxWidth: maxWidth? maxWidth : 800,
        mx: "auto",

        p: 8,
        px: { xs: 2, sm: 7, md: 25 },
        textAlign: "center",
        borderRadius: 4,
        backgroundColor: "#fff",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        position: "relative",
      }}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        sx={{
          width: "90px",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9241.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Box
        position="absolute"
        bottom={0}
        right={0}
        sx={{
          width: "90px",
          borderBottomRightRadius: "15px",
          borderBottomLeftRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9240.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Grid container spacing={1}>

        
        <Grid item xs={12}>
          <Box
            sx={{
              width: topimageWidth ? topimageWidth : 180,
              // height: 180,
              mx: "auto",
             
            }}
          >
           {topImage}
          </Box>
        </Grid>

        {/* Title */}
        <Grid item xs={12} mt={2}>
          {" "}
          <Typography
            fontSize="24px"
            color="#572575"
            sx={{
              fontWeight: 700,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: "1.4",
            }}
          >
            {text}
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="16px"
            color="#555555"
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: 1.5,
            }}
          >
            {subText}
          </Typography>
        </Grid>

       
      </Grid>
    </Box>
  )
}
